<div *ngIf="!showHorizontalMenu()" class="vertical-menu" [ngClass]="locale==Locales.BN_BN? 'font-bn-nav':'font-en'" [@slideIn]="!isMenuCollapsed" @expanded>

  <div data-simplebar class="h-100">

    <!--- Sidemenu -->
    <div id="sidebar-menu">
      <!-- Left Menu Start -->
      <ul class="metismenu list-unstyled" id="side-menu">
        <li class="menu-title" key="t-menu" i18n="@@label.Menu">Menu</li>

        <li *ngFor="let group of menu">
          <a (click)="onMenuGroupClick(group)"
             href="javascript: void(0);" class="has-arrow waves-effect">
            <i class="{{group.icon}}"></i>
            <span key="t-dashboards">{{ group.title | appTranslate }}</span>
          </a>
          <ul *ngIf="group.expanded" class="sub-menu" aria-expanded="true">
            <li *ngFor="let item of group.items" [ngClass]="item.selected?'bg-primary-subtle':''">
              <a href="javascript: void(0);" (click)="onMenuItemClick(item)"
                 [ngClass]="item.selected?'text-primary':''"
                 key="t-saas">{{ item.title | appTranslate }}</a>
            </li>
          </ul>
        </li>

      </ul>
    </div>
<!--    <div class="logo-container">-->
<!--      <img src="assets/apanel/images/logos/logo-wide.svg" alt="Logo"><br/>-->
<!--      <small><em class="text-primary-brand">Powered by-->
<!--        <strong>Cognito Labs Ltd</strong></em>-->
<!--      </small><br/>-->
<!--    </div>-->
    <!-- Sidebar -->
  </div>
</div>

<div *ngIf="showHorizontalMenu()" class="topnav" [ngClass]="locale==Locales.BN_BN? 'font-bn-nav':'font-en'">
  <div class="container-fluid">
    <nav class="navbar navbar-light navbar-expand-lg topnav-menu">

      <div class="collapse navbar-collapse scrollable-container" id="topnav-menu-content">
        <ul class="navbar-nav horizontal-scroll ">

          <li class="nav-item dropdown" *ngFor="let group of menu">
            <a (click)="onMenuGroupClick(group)"
               class="nav-link dropdown-toggle arrow-none" id="topnav-dashboard" role="button">
              <i class="{{group.icon}}"></i> &nbsp;
              <span key="t-dashboards">{{ group.title | appTranslate }}</span>
            </a>
            <ul class="dropdown-menu" aria-labelledby="topnav-dashboard">

              <div *ngFor="let item of group.items">

              <a href="javascript:void(0);" (click)="onMenuItemClick(item)"  class="dropdown-item" key="t-default">
                  {{ item.title | appTranslate }}
              </a>
              </div>
<!--              <a href="dashboard-saas.html" class="dropdown-item" key="t-saas">Saas</a>-->
<!--              <a href="dashboard-crypto.html" class="dropdown-item" key="t-crypto">Crypto</a>-->
<!--              <a href="dashboard-blog.html" class="dropdown-item" key="t-blog">Blog</a>-->
<!--              <a href="dashboard-job.html" class="dropdown-item" key="t-Jobs">Jobs</a>-->
            </ul>
          </li>

        </ul>
      </div>
    </nav>
  </div>
</div>
